import { stringToEnum } from "@ms/uno-utilities/lib/local/EnumUtilities";
import { TimeDisplayMode } from "../../service/planner/entities/IUserSettingsResource";
export { TimeDisplayMode };
/** Default time settings applied when no roaming value is present or the stored value is invalid. */ export const defaultUserTimeSettings = {
    timeDisplayMode: TimeDisplayMode.UserTimeZone,
    showTime: true
};
/**
 * Parse an unknown value from a roaming JSON blob into an `IUserTimeSettings`. Any field that is
 * missing, of the wrong type, or an unrecognised enum value falls back to the default. This lets
 * legacy blobs (written before these fields existed) and future-client blobs (with values this
 * client doesn't know) round-trip safely.
 */ export function parseUserTimeSettings(value) {
    const raw = typeof value === "object" && value !== null ? value : {};
    return {
        timeDisplayMode: (typeof raw.timeDisplayMode === "string" ? stringToEnum(raw.timeDisplayMode, TimeDisplayMode) : null) ?? defaultUserTimeSettings.timeDisplayMode,
        showTime: typeof raw.showTime === "boolean" ? raw.showTime : defaultUserTimeSettings.showTime
    };
}
